import React from "react"
import { Button, Container, Row, Col } from "react-bootstrap"
import { Link } from "gatsby"
import styled from "styled-components"
import { BiArrowBack } from "react-icons/bi"

const Header = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  .item {
    padding: 1rem 0;
  }
`

const GalleryHeader = ({ title }) => {
  return (
    <Header>
      <div className="item">
        <h1>{title}</h1>
      </div>
      <div className="item">
        <Link to="/gallery">
          <Button
            variant="light"
            style={{
              display: "flex",
              flexFlow: "row nowrap",
              alignItems: "center ",
              justifyContent: "space-between",
            }}
          >
            <BiArrowBack size={20} style={{ marginRight: 10 }} />
            Back
          </Button>
        </Link>
      </div>
    </Header>
  )
}

export default GalleryHeader
